<div class="subtitlebar">
	<i class="subtitlebar__back fa fa-angle-left" (click)="onBack()"></i>
	<h2 class="subtitlebar__title">{{ 'IMPRINT.TITLE' | translate }}</h2>
</div>
<div class="imprint">
	<div class="imprint__text" [innerHTML]="'IMPRINT.TEXT1' | translate"></div>
	<div class="imprint__text" [innerHTML]="'IMPRINT.TEXT2' | translate"></div>
	<div class="imprint__text" [innerHTML]="'IMPRINT.TEXT3' | translate"></div>
</div>



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/imprint/imprint.component.html